<template>
  <b-modal v-model="isModalVisible" :no-close-on-backdrop="noCloseOnBackdrop" :size="size" @hidden="hideModal()" ignore-enforce-focus-selector=".trumbowyg-modal .trumbowyg-modal-box">
    <div slot="modal-header">
      <span class="h6">
        <slot name="header">
        </slot>
      </span>
      <button type="button" aria-label="Close" class="close" @click="hideModal()">
        ×
      </button>
    </div>
    <slot name="body">
    </slot>
    <div slot="modal-footer" class="w-100">
      <div class="btn-group float-right">
        <button v-if="isDeletable" type="button" class="btn btn-sm btn-link fa fa-trash fa-lg" @click="deleteItem()" v-b-tooltip.hover :title="$t('buttons.delete')"></button>
        <button v-if="isEditable" type="button" class="btn btn-sm btn-link fa fa-edit fa-lg" @click="editItem()" v-b-tooltip.hover :title="$t('buttons.edit')"></button>
        <button v-if="isArchivable" type="button" class="btn btn-sm btn-link fa fa-file-archive fa-lg" @click="archiveItem()" v-b-tooltip.hover :title="$t('buttons.archive')"></button>
        <button v-if="isSavable" type="button" class="btn btn-sm btn-link fa fa-check fa-lg" @click="saveItem()" v-b-tooltip.hover :title="$t('buttons.save')"></button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'BaseModal',
  data () {
    return {
      isModalVisible: this.isVisible
    }
  },
  props: {
    noCloseOnBackdrop: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    isVisible: {
      type: Boolean,
      required: true
    },
    size: {
      type: String,
      required: false,
      default () {
        return 'md'
      }
    },
    isDeletable: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    isSavable: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    isEditable: {
      type: Boolean,
      required: false,
      default () {
        return true
      }
    },
    isArchivable: {
      type: Boolean,
      required: false,
      default () {
        return true
      }
    }
  },
  watch: {
    'isVisible' (val) {
      this.isModalVisible = val
    }
  },
  methods: {
    editItem () {
      this.$emit('editItem')
    },
    archiveItem () {
      this.$emit('archiveItem')
    },
    deleteItem () {
      this.$emit('deleteItem')
    },
    hideModal () {
      if (this.isVisible) this.$emit('hideModal')
    },
    saveItem () {
      this.$emit('saveItem')
    }
  }
}
</script>

<style scoped>

</style>
